import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders icon for the integrations */
export function IntegrationIcon(t0) {
  const $ = _c(4);
  const {
    icon
  } = t0;
  const Icon = icon;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "95px",
      height: "95px",
      backgroundColor: "surfaces.secondary",
      display: "grid",
      placeItems: "center",
      borderRadius: "10px",
      boxShadow: `0 1px 0 0 ${PALETTE_VARS.divider}`
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "65px",
      height: "65px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== Icon) {
    t3 = <Box sx={t1}><Icon sx={t2} /></Box>;
    $[2] = Icon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}